<template>
  <div class="box">
    <b-tabs v-model="activeTab" position="is-centered" type="is-toggle-rounded" expanded>
      <b-tab-item :label="loginFirst ? 'Login' : 'Sign Up'" :icon="loginFirst ? 'login' : 'account-plus'">
        <sign-up-form v-if="!loginFirst" :is-boxed="false" @userUpdated="$emit('userUpdated', $event)" />
        <login-form v-else hide-sign-up-link :is-boxed="false" @userUpdated="$emit('userUpdated', $event)" />
      </b-tab-item>

      <b-tab-item :label="loginFirst ? 'Sign Up' : 'Login'" :icon="loginFirst ? 'account-plus' : 'login'">
        <sign-up-form v-if="loginFirst" :is-boxed="false" @userUpdated="$emit('userUpdated', $event)" />
        <login-form v-else hide-sign-up-link :is-boxed="false" @userUpdated="$emit('userUpdated', $event)" />
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import LoginForm from '@/components/misc/LoginForm';
import SignUpForm from '@/components/misc/SignUpForm';

export default {
  components: {
    LoginForm,
    SignUpForm
  },
  props: {
    loginFirst: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: 0
    }
  }
}
</script>

<style scoped>

</style>